module.exports = __webpack_public_path__ + "media/images/eu-logo-rect-7ff1b293b1da98b5650b0d75689c4233.png";